import $ from 'jquery'
// window.$ = $
// window.jQuery = jQuery

import AirDatepicker from 'air-datepicker'
import 'air-datepicker/air-datepicker.css'
import localeEn from 'air-datepicker/locale/en'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import Swiper, { Navigation, Autoplay, Pagination } from 'swiper'
Swiper.use([Navigation, Autoplay, Pagination])

import 'magnific-popup'
import { CountUp } from 'countup.js/dist/countUp.min'
import 'jquery-touchswipe'
import { debounce } from 'debounce'
import Inputmask from 'inputmask'
import Stickyfill from 'stickyfilljs'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

const pickersElements = document.querySelectorAll('.datepicker-here')
pickersElements.forEach(item => {
  new AirDatepicker(item, {
    minDate: Date.now(),
    locale: localeEn,
    timepicker: true,
    timeFormat: 'hh:mm',
    dateFormat: 'dd.mm.yy',
    position: 'top left'
  })
})

$(document).ready(function () {
  const sticky = $('.sticky')
  Stickyfill.add(sticky)

  const counters = []
  $('[data-count-up]').each(function () {
    const $el = $(this)
    const count = $el.data('count-up')
    const tech = new CountUp($el[0], count, { duration: 4 })
    counters.push({
      $el,
      tech
    })
  })
  if (counters.length > 0) {
    $(window)
      .scroll(function () {
        const st = $(window).scrollTop()
        for (const counter of counters) {
          if (!counter.activated) {
            const offset = counter.$el.offset().top - $(window).height()
            if (st >= offset) {
              counter.tech.start()
              counter.activated = true
            }
          }
        }
      })
      .trigger('scroll')
  }

  const menu = []
  $('.wwd-slider__title').each(function () {
    menu.push($(this).text())
  })
  new Swiper('.js-wwd-slider', {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 30,
    autoplay: {
      delay: 6000
    },
    navigation: {
      nextEl: '.wwd-navigation__right',
      prevEl: '.wwd-navigation__left'
    },
    pagination: {
      el: '.wwd__pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + menu[index] + '</span>'
      }
    }
  })

  const resultsSlider = new Swiper('.js-results-slider', {
    // loop: true,
    slidesPerView: 1,
    autoHeight: true,
    centeredSlides: true,
    loop: true,
    autoplay: {
      duration: 2500
    },
    navigation: {
      nextEl: '.results-navigation__right',
      prevEl: '.results-navigation__left'
    }
  })

  const target = $('.main')
  if (target.length > 0) {
    const targetPos = target.offset().top
    const targetHeight = target.outerHeight()
    const winHeight = $(window).height()
    const navigator = $('.navigator')
    debounce(function () {
      window.dispatchEvent(new Event('resize'))
    }, 50)
    $(window).scroll(function () {
      const winScrollTop = $(this).scrollTop()
      if (
        winScrollTop > targetPos - winHeight / 2 &&
        winScrollTop < targetPos + targetHeight - (winHeight - 100)
      ) {
        navigator.addClass('active')
        target.addClass('navigator-active')
        $('.navigator__link').removeClass('prev')
        $('.navigator__link').removeClass('next')
        $('.navigator__link.mPS2id-highlight-last').prev().addClass('prev')
        $('.navigator__link.mPS2id-highlight-last').next().addClass('next')
      } else {
        navigator.removeClass('active')
        target.removeClass('navigator-active')
      }
      window.dispatchEvent(new Event('resize'))
    })
  }

  $('.swiper-container').each(function (elem, target) {
    const swp = target.swiper
    if (swp) {
      $(this).hover(
        function () {
          swp.autoplay.stop()
        },
        function () {
          if (!swp._dontStart) {
            swp.autoplay.start()
          }
        }
      )
    }
  })
  $('.results__photo-row').each(function () {
    $(this).magnificPopup({
      delegate: 'a[data-image-popup]', // the selector for gallery item
      type: 'image',
      gallery: {
        enabled: true
      },
      callbacks: {
        open: function () {
          disableBodyScroll($('.mfp-wrap')[0])
          $('.mfp-gallery').css('overflow', 'auto')
          resultsSlider.autoplay.stop()
          resultsSlider._dontStart = true
        },
        close: function () {
          resultsSlider.autoplay.start()
          resultsSlider._dontStart = false
          clearAllBodyScrollLocks()
        }
      }
    })
  })
  $('[data-image-popup]').each(function () {
    if ($(this).parents('.results__photo-row').length === 0) {
      $(this).magnificPopup({
        type: 'image',
        callbacks: {
          open: function () {
            $('body').addClass('mfp-zoom-out-cur')
            disableBodyScroll($('.mfp-wrap')[0])
            $('.mfp-gallery').css('overflow', 'auto')
          },
          close: function () {
            $('body').removeClass('mfp-zoom-out-cur')
            clearAllBodyScrollLocks()
          }
        }
      })
    }
  })
  $('[data-images-gallery]').each(function () {
    const items = []
    const temple = $(this).data('images-gallery')
    for (const img in temple) {
      items.push({
        src: `
                    <div class="img-gal">
                    <img class="img-gal__image" src="${temple[img].image}">
                    <a href="${temple[img].link}" class="btn" target="_blank">Visit Website</a>
                    </img>
                `,
        type: 'inline'
      })
    }

    $(this).magnificPopup({
      items: items,
      gallery: {
        enabled: true
      },
      type: 'image',
      callbacks: {
        open: function () {
          $('body').addClass('mfp-zoom-out-cur')
          disableBodyScroll($('.mfp-wrap')[0])
          $('.mfp-gallery').css('overflow', 'auto')
        },
        close: function () {
          $('body').removeClass('mfp-zoom-out-cur')
          clearAllBodyScrollLocks()
        }
      }
    })
  })
  $('.--readonly-input').prop('readonly', true)
  if ($('input[type=tel]').length > 0) {
    const im = new Inputmask('(999) 999-9999')
    im.mask($('input[type=tel]')[0])
  }
  if ($('input[data-zip]').length > 0) {
    const im = new Inputmask('99999')
    im.mask($('input[data-zip]')[0])
  }

  ; (function () {
    const magnificPopupInst = $.magnificPopup.instance
    $('[data-images-gallery]').click(function () {
      setTimeout(function () {
        $('.mfp-container').swipe({
          swipeLeft: function () {
            magnificPopupInst.next()
          },
          swipeRight: function () {
            magnificPopupInst.prev()
          }
        })
      }, 500)
    })
  }.call(this))
})